// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/ticketservice/tickets.actions.go

export const UPDATE_TICKET_FOR_CASE =
  "mondoo.integrations.tickets.TicketSystemIntegration.UpdateTicketForCase";
